import useJwt from '@core/auth/jwt/useJwt'
import axios from '@axios'

const { jwt } = useJwt(
  axios,
  {
    // Endpoints
    loginEndpoint: '/token/',
    registerEndpoint: '/jwt/register',
    refreshEndpoint: '/token/refresh/',
    logoutEndpoint: '/token/logout/',

    // Tokens live in httpOnly cookies (see jwtService.js), not a header we
    // set or a key we store in localStorage -- no tokenType/storage keys
    // needed here any more.
  },
)
export default jwt
